import { message, MessageArgsProps } from 'antd';
import './style.css';

const applicationMessage = (
  type: 'open' | 'success' | 'error' | 'info' | 'warning' | 'loading',
  props: MessageArgsProps,
  mode: 'dark' | 'light' = 'dark'
) => {
  const className =
    mode === 'dark'
      ? `${props.className || ''} ant-message-dark-mode`
      : props.className || '';

  return message[type]({
    ...props,
    className
  });
};

export default applicationMessage;
